import {
  autorun, makeAutoObservable, reaction, runInAction,
} from 'mobx';
import api from '../../api';
import { inComeTypesObject } from '../../helpers/PortfolioProject/IncomeHelper';

export class IncomeProjStore {
  // currentObject = null
  allIncomes = null;

  selectorsStatuses = {
    head: 'react-valid',
    institute: 'react-valid',
    type: 'react-valid',
    year: 'react-valid',
  };

  allInstitutes = null;

  allTypes = null;

  filters = {
    year: null,
    status: null,
  };

  formObject = {};

  constructor() {
    makeAutoObservable(this);
    reaction(() => this.formObject?.head, (value, prevValue) => {
      if (!prevValue && !!value) {
        this.updateSelectorsClassPrefix('head', 'react-valid');
      }
    });
    reaction(() => this.formObject?.institute, (value, prevValue) => {
      if (!prevValue && !!value) {
        this.updateSelectorsClassPrefix('institute', 'react-valid');
      }
    });
    reaction(() => this.formObject?.type, (value, prevValue) => {
      if (!prevValue && !!value) {
        this.updateSelectorsClassPrefix('type', 'react-valid');
      }
    });
    reaction(() => this.formObject?.year, (value, prevValue) => {
      if (!prevValue && !!value) {
        this.updateSelectorsClassPrefix('year', 'react-valid');
      }
    });

    api.get('/structure/institutes').then((x) => this.setAllInstitutes(x));
  }

  changeFilter(name, value) {
    const changePromise = new Promise(((resolve) => {
      runInAction(() => {
        this.filters[name] = value !== 'null' ? value : null;
        resolve();
      });
    }));
    return changePromise;
  }

  updateAllIncomes(allIncomes) {
    this.allIncomes = allIncomes;
  }

  updateFormObject(...args) {
    const [value, propertyName] = args;

    this.formObject = { ...this.formObject, [propertyName]: value };

    if (this.formObject[propertyName].hasOwnProperty('label') && this.formObject[propertyName].label.length === 0) {
      this.formObject = { ...this.formObject, [propertyName]: null };
    }
  }

  setFormObject(currObject) {
    currObject.institute = { value: currObject?.institute, label: currObject?.institute };
    currObject.type = { value: currObject.type, label: currObject.type };
    currObject.head = { ...currObject.head, label: `${currObject.head?.lastName} ${currObject.head?.firstName} ${currObject.head?.middleName}` };
    this.formObject = currObject;
  }

  updateSelectorsClassPrefix(statusName, statusProperty) {
    this.selectorsStatuses = { ...this.selectorsStatuses, [statusName]: statusProperty };
  }

  clearAllSelectors() {
    this.selectorsStatuses = {
      head: 'react-valid',
      institute: 'react-valid',
      type: 'react-valid',
      year: 'react-valid',
    };
  }

  clearIncomeOnExitCard() {
    this.clearAllSelectors();
    this.formObject = {};
    this.filters = {
      year: null,
      status: null,
    };
  }

  clearAllStore() {
    this.clearIncomeOnExitCard();
    this.allIncomes = null;
    this.filters = {
      year: null,
      status: null,
    };
  }

  setAllInstitutes(allInstitutes) {
    this.allInstitutes = allInstitutes;
  }
}
